/* tslint:disable */
/* eslint-disable */
/**
 * Microtech partes API
 * API Library for SmartyBar application
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ReportLinesApi - axios parameter creator
 * @export
 */
export const ReportLinesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLineIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportLineIdDelete.');
            }
            const localVarPath = `/reportLine/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLineIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportLineIdGet.');
            }
            const localVarPath = `/reportLine/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLineIdPut: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportLineIdPut.');
            }
            const localVarPath = `/reportLine/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create reportLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLinePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reportLine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of reportLines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLinesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reportLines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const url = localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash
            delete localVarRequestOptions.params
            return {
                url,
                options: localVarRequestOptions,
            };
        },

        /**
         * 
         * @summary Returns a list of reportLines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLinesGetUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reportLinesuser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const url = localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash
            delete localVarRequestOptions.params
            return {
                url,
                options: localVarRequestOptions,
            };
        },

        /**
         * 
         * @summary Returns a list of reportLines
         * @param {string} idParte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportLinesIdParteGet: async (idParte: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idParte' is not null or undefined
            if (idParte === null || idParte === undefined) {
                throw new RequiredError('idParte','Required parameter idParte was null or undefined when calling reportLinesIdParteGet.');
            }
            const localVarPath = `/reportLines/{idParte}`
                .replace(`{${"idParte"}}`, encodeURIComponent(String(idParte)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportLinesApi - functional programming interface
 * @export
 */
export const ReportLinesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLineIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Returns a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLineIdGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdPut(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLineIdPut(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Create reportLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLinePost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Returns a list of reportLines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLinesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },

        /**
         * 
         * @summary Returns a list of reportLines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinesGetUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLinesGetUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },

        /**
         * 
         * @summary Returns a list of reportLines
         * @param {string} idParte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinesIdParteGet(idParte: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await ReportLinesApiAxiosParamCreator(configuration).reportLinesIdParteGet(idParte, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
    }
};

/**
 * ReportLinesApi - factory interface
 * @export
 */
export const ReportLinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdDelete(id: string, options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLineIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdGet(id: string, options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLineIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a reportLine by ID
         * @param {string} id The reportLine id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLineIdPut(id: string, options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLineIdPut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create reportLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinePost(options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLinePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of reportLines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinesGet(options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLinesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of reportLines
         * @param {string} idParte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportLinesIdParteGet(idParte: string, options?: AxiosRequestConfig): Promise<any> {
            return ReportLinesApiFp(configuration).reportLinesIdParteGet(idParte, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportLinesApi - object-oriented interface
 * @export
 * @class ReportLinesApi
 * @extends {BaseAPI}
 */
export class ReportLinesApi extends BaseAPI {
    /**
     * 
     * @summary Update a reportLine by ID
     * @param {string} id The reportLine id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLineIdDelete(id: string, options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLineIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns a reportLine by ID
     * @param {string} id The reportLine id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLineIdGet(id: string, options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLineIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Update a reportLine by ID
     * @param {string} id The reportLine id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLineIdPut(id: string, options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLineIdPut(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Create reportLine
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLinePost(options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLinePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns a list of reportLines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLinesGet(options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLinesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of reportLines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLinesGetUser(options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLinesGetUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of reportLines
     * @param {string} idParte 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportLinesApi
     */
    public async reportLinesIdParteGet(idParte: string, options?: AxiosRequestConfig) : Promise<any> {
        return ReportLinesApiFp(this.configuration).reportLinesIdParteGet(idParte, options).then((request) => request(this.axios, this.basePath));
    }
}
